import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// @mui
import { styled } from '@mui/material/styles';
import { Link, Container, Typography, Stack } from '@mui/material';
// components
import Page from '../components/Page';
// sections
import { RegisterForm } from '../sections/auth/register';
import { useEffect, useState } from 'react';
import { isLoggedIn } from 'utils';
import { toggleLoading } from 'store/actions';
import RegisterWithOtp from '../sections/auth/register/RegisterWithotp';
import { Icon } from '@iconify/react';

const HOME_URL = process.env.REACT_APP_HOME_URL;

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Register() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [email, setEmail] = useState("");

  const { isAuthenticated } = useSelector(({ auth: { token } }) => ({
    isAuthenticated: isLoggedIn(token),
  }));

  const handlePage = (value) => {
    setPage(value);
  };

  const updateEmail = (value) => {
    setEmail(value);
  };

  useEffect(() => {
    dispatch(toggleLoading(false));
    if (isAuthenticated) {
      navigate('/dashboard/app', { replace: true });
    }
  }, []);

  return (
    <Page title="Register">
      <RootStyle>
        <Container>
          <ContentStyle>
            <Typography variant="h4" gutterBottom>
              Get started.
            </Typography>

            {!page ? (
              <RegisterForm dispatch={dispatch} nextPage={handlePage} updateEmail={updateEmail} />
            ) : (
              <RegisterWithOtp dispatch={dispatch} email={email} />
            )}

            <Typography variant="body2" sx={{ mt: 3, textAlign: 'center' }}>
              Already have an account?{' '}
              <Link variant="subtitle2" to="/login" component={RouterLink}>
                Login
              </Link>
            </Typography>
          </ContentStyle>
        </Container>
      </RootStyle>
      <Stack style={{
        position: "fixed",
        bottom: 0,
        textAlign: 'center',
        width: '100%',
        padding: "5px 0",
        backgroundColor: "#fff",
      }}>
        <Link variant="subtitle2">
          <Icon
            width="30"
            cursor='pointer'
            icon="ant-design:home-filled"
            onClick={() => window.open(HOME_URL, "_self")}
          />
        </Link>
      </Stack>
    </Page>
  );
}
